import {
  Address, GroupSelection, Price, Selection,
} from '@printdeal/product-selector';
import { configurationProvider } from '@printdeal/configuration';
import Api from '../Api';

export interface GetProductPricesParams {
  productKey: string;
  selection: Selection;
  address: Address;
  quantity: number[];
  customerGroupId?: string;
  group?: GroupSelection[];
  productVersion: number;
}

class ProductService extends Api {
  /**
   * This can be used as a fetcher
   */
  get = async <T>(url: string) => {
    const { data } = await this.httpClient.get<T>(url);
    return Promise.resolve(data);
  };

  validateSelection = async ({
    selection,
    comboSelection,
    productDetailPageId,
    customerGroupId,
    quantity,
    deliveryOptionId,
  }: {
    selection: string;
    comboSelection: string;
    productDetailPageId: string;
    customerGroupId?: string;
    quantity?: string;
    deliveryOptionId?: string;
  }): Promise<{ valid: boolean; price: Price; originalPrice: Price }> => {
    const params = new URLSearchParams();
    params.append('storeKey', configurationProvider.getValue('STORE_KEY'));
    params.append('selection', selection);

    if (comboSelection) {
      params.append('comboSelection', comboSelection);
    }

    if (customerGroupId) {
      params.append('customerGroupId', customerGroupId);
    }

    if (quantity) {
      params.append('quantity', quantity);
    }

    if (deliveryOptionId) {
      params.append('deliveryOptionId', deliveryOptionId);
    }

    const { data } = await this.httpClient.get(`/product/validate/${productDetailPageId}`, {
      params,
    });
    return Promise.resolve(data);
  };

  getProductDiscount = async ({
    productKey,
    quantity,
    centAmount,
    customerGroupId,
  }: {
    productKey: string;
    quantity?: number;
    centAmount?: number;
    customerGroupId?: string;
  }) => {
    const params = new URLSearchParams();
    params.append('storeKey', process.env.GATSBY_STORE || '');

    if (quantity) {
      params.append('quantity', String(quantity));
    }

    if (centAmount) {
      params.append('centAmount', String(centAmount));
    }

    if (customerGroupId) {
      params.append('customerGroupId', customerGroupId);
    }

    const { data } = await this.httpClient.get(`/product/${productKey}/discounts`, {
      params,
    });
    return Promise.resolve(data);
  };
}

export default ProductService;
